import { Props } from './types';
import S from './TripStyles';

function Trip({
  from,
  to,
}: Props): JSX.Element {
  return (
    <S.Wrapper
      className="overview-container"
    >
      <div className="trip-status">
        <div className="start" />
        <div className="middle" />
        <div className="end" />
      </div>
      <div className="description">
        <p className="title"> {from || ''} </p>
        <p className="subtitle"> {to} </p>
      </div>
    </S.Wrapper>
  );
}

export default Trip;
